
/**
 * create cookies.
 * @param  {string} name  name of cookie
 * @param  {object} value value store in cookie
 * @param  {number} sec   time cookie expire in second.
 * @return {null}       
 */
export function create (name, value, sec) {
    if (sec) {
        var date = new Date();
        date.setTime(date.getTime()+(sec*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

/**
 * read cookie from cookie's name
 * @param  {string} name name of target cookie to read.
 * @return {string}      cookie value in string or null if cookie not found.
 */
export function read (name){
	var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

/**
 * remore target cookie
 * @param  {string} name cookie name to remove
 * @return {null}      
 */
export function remove (name){
	this.create(name,"",-1);
} 


var cookie = {
	create,
	read,
	remove
}


export default cookie


/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/cookie.js
 **/